import React from "react";

import { AppContext } from "../../../../../lib/appContext";
import { ProviderData } from "../../../../../lib/appContext/types";
import { useSliderComponent } from "../../../../common/components/Slider";
import { getEducationImage } from "../../../../common/helpers/imageUrl";

import { TipCard } from "./TipCard";
import { ITipSlug, ITipsSliderProps } from "./types";

const toggleOpenDrawer = (toggleOpen: (slug: ITipSlug) => void, tipSlug: ITipSlug) => () =>
  toggleOpen(tipSlug);

const getTipImage = ({ businessUnitConfig, countryCode }: ProviderData, slug: string) =>
  getEducationImage(
    {
      businessUnitCode: businessUnitConfig.businessCode,
      countryCode
    },
    slug,
    "xs"
  );

export const TipSliderBase: React.FC<ITipsSliderProps> = ({ educationTips }) => {
  const TipSliderComponent = useSliderComponent();
  const appContext = React.useContext(AppContext);
  const [drawerOpen, setDrawerOpen] = React.useState<ITipSlug>(null);
  return (
    <TipSliderComponent>
      {educationTips.map(education =>
        education ? (
          <TipCard
            key={education.slug}
            educationTip={education}
            onClick={toggleOpenDrawer(setDrawerOpen, education.slug)}
            onClose={toggleOpenDrawer(setDrawerOpen, null)}
            imageUrl={getTipImage(appContext, education.slug)}
            hasDrawerOpen={drawerOpen === education.slug}
          />
        ) : null
      )}
    </TipSliderComponent>
  );
};
